import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";

let ob = {
  OrgId: null,
  EmailPurpose: false,
  OrgName: null,
  PurposeId: 0,
  NewDirectEmail: "",
  DomainName: null,
  Flag: false,
  NoReplay: false,
};
const AddOrgEmail = () => {
  const navigate = useNavigate();
  const { userToken, sharedObject, setXDRArr, SetSharedObject } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [answers, setAnswers] = useState(ob);
  const [processing, SetProcessing] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [returnMsg, SetReturnMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const [errEmail, SetErrEmail] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  useEffect(() => {
    const setEmails = async (obj) => {
      let o = {
        OrgId: obj?.id ? obj?.id : null,
        EmailPurpose: false,
        OrgName: obj?.name ? obj?.name : null,
        PurposeId: 0,
        NewDirectEmail: "",
        DomainName: obj?.domainName ? obj?.domainName : null,
        Flag: obj?.Flag ? obj?.Flag : false,
        NoReplay: obj?.NoReplay ? obj?.NoReplay : false,
      };
      await setAnswers(o);
    };
    setEmails(sharedObject.orgActionObj);
    return () => {
      SetFrmSubmFlag(false);
      SetErrMsg(false);
      SetReturnMsg(false);
      setAnswers(ob);
    };
  }, [sharedObject.orgActionObj]);
  const addEmailOrg = async () => {
    SetErrEmail(false);
    SetFrmSubmFlag(true);
    SetErrMsg(false);
    SetReturnMsg(false);
    if (
      answers.NewDirectEmail !== "" &&
      (containsSpacesOrSpecialChars(answers.NewDirectEmail) ||
        answers.NewDirectEmail.length < 4)
    ) {
      document.getElementById("NewDirectEmail").scrollIntoView();
      document.getElementById("NewDirectEmail").focus();
      SetErrEmail(true);
      return;
    }
    SetProcessing(true);
    let call =
      "/emails/AddOrganizationDirectEmail?orgId=" +
      answers.OrgId +
      "&newDirectEmail=" +
      answers.NewDirectEmail +
      "&purposeId=" +
      answers.PurposeId +
      "&domainName=" +
      answers.DomainName +
      "&emailPurpose=" +
      answers.EmailPurpose +
      "&emailNoReplay=" +
      answers.NoReplay;
    const res = await CallAPI(call, null, "get", userToken, false);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetMsg("Direct email has been added successfully.");
      SetProcessing(false);
      SetReturnMsg(true);
      if (answers.Flag) SetSharedObject("reloadEmailList", true);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        if (msg.includes("Cannot insert duplicate key")) {
          SetMsg(
            "Email already exists. Please try again with a different name."
          );
        } else {
          SetMsg(
            "System encoountered an error. Please try again. If the problem persists, please contact your administrator."
          );
        }
      }
      SetErrMsg(true);
      SetReturnMsg(true);
      SetProcessing(false);
    }
  };
  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
  };
  return (
    <div className="AddOrgEmail">
      <div
        className="modal fade"
        id="AddOrgEmailModal"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="Add Org Email Modal"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                {" "}
                Add Organization Email{" "}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-form">
                <form className="needs-validation" noValidate>
                  <div className="field-wrapper">
                    <label>Organization:</label>
                    <span className="text-size6">{answers?.OrgName}</span>
                  </div>
                  <div className="field-wrapper">
                    <label for="forgotUser">Email Name</label>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control field-direct"
                        placeholder="Enter new email name"
                        aria-describedby="basic-addon2"
                        maxLength={"63"}
                        id="NewDirectEmail"
                        value={answers?.NewDirectEmail}
                        onChange={(el) => {
                          SetReturnMsg(false);
                          SetErrMsg(false);
                          setAnswer("NewDirectEmail", el.target.value);
                        }}
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text field-direct-addon"
                          id="basic-addon2"
                        >
                          @{answers?.DomainName}
                        </span>
                      </div>
                    </div>
                    {answers?.NewDirectEmail === "" && frmSubmFlag ? (
                      <div className="alert alert-danger">
                        Email Name field is required.
                      </div>
                    ) : null}
                    {errEmail ? (
                      <div className="alert alert-danger">
                        Please enter a valid email name with no spaces, commas,
                        or special characters.
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper w-set1">
                    <label for="PurposeId">
                      What is the purpose of this email?
                    </label>
                    <div className="email-purpose-wrapper">
                      <select
                        className="form-control"
                        name="PurposeId"
                        id={"PurposeId"}
                        value={answers?.PurposeId}
                        onChange={(el) => {
                          setAnswer("PurposeId", el.target.value);
                        }}
                      >
                        <option value={0}>General</option>
                        <option value={1}>Medical Records XML only</option>
                        <option value={2}>Medical Records</option>
                        <option value={3}>Administrative</option>
                      </select>
                    </div>
                    {answers?.PurposeId === "" && frmSubmFlag ? (
                      <div className="alert alert-danger">
                        Purpose field is required.
                      </div>
                    ) : null}
                  </div>

                  <div className="field-wrapper w-set2">
                    <label for="forgotUser">Sharing Allowed?</label>
                    <a
                      href="#OrgShareInfo"
                      data-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="OrgShareInfo"
                    >
                      <i className="bi bi-plus-lg sm-icon-container"></i>
                    </a>
                    <div className="collapse notes-msg-sm" id="OrgShareInfo">
                      If sharing is not allowed, then only one member can be
                      assigned to this email.
                    </div>
                    <div className="email-purpose-wrapper">
                      <select
                        className="form-control"
                        name="EmailPurpose"
                        id="EmailPurpose"
                        value={answers?.EmailPurpose}
                        onChange={(el) => {
                          setAnswer("EmailPurpose", el.target.value);
                        }}
                      >
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </select>
                    </div>
                    {answers?.EmailPurpose === "" && frmSubmFlag ? (
                      <div className="alert alert-danger">
                        Email Sharing Allowed field is required.
                      </div>
                    ) : null}
                  </div>

                  {/*<div className="field-wrapper">*/}
                  {/*  <div className="NoReply spacer-inline">*/}
                  {/*    <input*/}
                  {/*      className="form-control spacer-margin5 sp-mx"*/}
                  {/*      type="checkbox"*/}
                  {/*      id="NoReplay"*/}
                  {/*      value={answers?.NoReplay}*/}
                  {/*      onChange={(el) => {*/}
                  {/*        setAnswer("NoReplay", el.target.checked);*/}
                  {/*      }}*/}
                  {/*    />*/}
                  {/*  </div>*/}
                  {/*  <label className="v-top">Set as no-reply mailbox</label>*/}
                  {/*  <aside className="sp-margin13 line-s1">*/}
                  {/*    Check this box if this mailbox cannot reply to emails.*/}
                  {/*  </aside>*/}
                  {/*</div>*/}

                  {returnMsg ? (
                    <div className="AlertMessages">
                      <div
                        className={`alert alert-${
                          errMsg ? "danger" : "success"
                        }`}
                        role="alert"
                      >
                        {msg}
                      </div>
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
            <div className="modal-footer">
              {processing ? (
                <div className="loading"></div>
              ) : //<div className="spacer-inline">
              //  <div className="reverse-spinner spinner1"></div>
              //  <div className="spacer-inline spacer-margin2 dg-clr">
              //    Processing...
              //  </div>
              //</div>
              null}

              <button
                type="button"
                className="btn btn-success"
                onClick={(e) => addEmailOrg()}
              >
                Add Email
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrgEmail;
